import React, { useEffect, useState } from 'react';
import { Space, Checkbox } from 'antd';

import { useIntl } from 'common/config/i18n';

const WEEKDAYS = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
  sun: 7,
} as const;

type Weekday = keyof typeof WEEKDAYS;

const toWeekdaysObjFormat = (weekdays: string): { [key in Weekday]: boolean } => {
  return {
    mon: weekdays.indexOf('1') !== -1 || false,
    tue: weekdays.indexOf('2') !== -1 || false,
    wed: weekdays.indexOf('3') !== -1 || false,
    thu: weekdays.indexOf('4') !== -1 || false,
    fri: weekdays.indexOf('5') !== -1 || false,
    sat: weekdays.indexOf('6') !== -1 || false,
    sun: weekdays.indexOf('7') !== -1 || false,
  };
};

const formatOutput = (weekdays: { [key in Weekday]: boolean }): string => {
  return `${weekdays.mon ? '1' : ''}${weekdays.tue ? '2' : ''}${weekdays.wed ? '3' : ''}${weekdays.thu ? '4' : ''}${
    weekdays.fri ? '5' : ''
  }${weekdays.sat ? '6' : ''}${weekdays.sun ? '7' : ''}`;
};

interface Props {
  /** string like "1234567" 1 is monday */
  onChange: (output: string) => void;
  /** string like "1234567" 1 is monday */
  value: string;
}

const InputWeekdays: React.FC<Props> = ({ onChange, value }) => {
  const { t } = useIntl();
  const [weekdays, setWeekdays] = useState<{ [key in Weekday]: boolean }>(toWeekdaysObjFormat(value));

  useEffect(() => {
    setWeekdays(toWeekdaysObjFormat(value));
  }, [value]);

  return (
    <Space direction="horizontal" size="small">
      {Object.keys(WEEKDAYS).map((day) => (
        <Checkbox
          key={day}
          style={{ flexDirection: 'column', alignItems: 'center', height: 36 }}
          checked={weekdays[day as Weekday]}
          onChange={(e) => {
            const updatedWeekdays = { ...weekdays, [day]: e.target.checked };
            setWeekdays(updatedWeekdays);
            onChange(formatOutput(updatedWeekdays));
          }}
        >
          {t('weekdaysInput', day as Weekday)}
        </Checkbox>
      ))}
    </Space>
  );
};

export default InputWeekdays;
